'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Front';
import numeral from 'numeral';
import moment from 'moment';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import BookingComponent from 'Components/Front/Booking/BookingComponentInit';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { days_config, b_seminar_ranges } from 'Shared/options';
import { safeNumeral, formatNum, getUrlParameter, num, getOpenInfos } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const qwest = window.qwest;
const app = window.app;
export default class FrontBookingPage extends Component {
  state = {
    loading: false,
    people: window.localStorage.getItem('widget-people') || '',
    date: window.localStorage.getItem('widget-date') || '',
    start: window.localStorage.getItem('widget-start') || '',
    end: window.localStorage.getItem('widget-end') || '',
    amount: window.localStorage.getItem('amount') || '',
    disposition: window.localStorage.getItem('widget-disposition') || '',
    status_messages: {},
    step: 0,
    paid: false,
    offline_booking: getUrlParameter('token') ? true : false
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (getUrlParameter('token')) {
      component.verifyPaymentToken();
    } else {
      component.fetchSpace();
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.space && component.need_availability === true) {
      component.fetchAvailability({});
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    Object.keys(component.requests).forEach(name => component.requests[name]?.abort());
    component.requests = {};
  }
  verifyPaymentToken = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/token/verify-back-payment-token', {
      token: getUrlParameter('token')
    }).then(function (xhr, response) {
      const booking = response.booking;
      window.localStorage.setItem('booking-space-id', booking.coworking_space.id);
      window.localStorage.setItem('amount', formatNum(booking.amount, '0.00'));
      component.setState({
        loading: false,
        date: booking.date,
        people: booking.number_of_people,
        start: booking.start_hour,
        end: '',
        space: booking.coworking_space,
        amount: booking.amount,
        services: booking.services,
        disposition: booking.disposition,
        booking_id: booking.id
      });
      component.fetchSpace();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchAvailability = ({
    date,
    people
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!date && !state.date || !state.space) return;
    const date_value = date || state.date;
    component.need_availability = false;
    if (component.requests['fetchAvailability']) {
      component.requests['fetchAvailability']?.abort();
      delete component.requests['fetchAvailability'];
    }
    const people_count = typeof people === 'undefined' ? num(state.people, 0) : num(people, 0);
    component.setState({
      loading: true,
      date: date_value
    });
    const [is__open, is__custom] = getOpenInfos({
      schedule: state.space.schedule,
      availability: state.space.availabilities,
      type: state.space.type,
      date: date_value
    });
    if (!is__open) {
      return component.setState({
        loading: false,
        closed: true,
        special_closing: is__custom,
        error: 'Cet espace est fermé le ' + moment(date).format('DD/MM/YYYY') + '. Si vous avez plusieurs fenêtes myWO ouvertes, nous vous conseillons de fermer celle-ci et de compléter votre réservation depuis une autre.'
      });
    }
    const seats = num(state.space.number_seat, 0);
    component.requests['fetchAvailability'] = qwest.post(action('getSpaceBooking'), {
      coworking_space_id: state.space.id,
      date: date_value
    }).then(function (xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      delete component.requests['fetchAvailability'];
      numeral.locale('en');
      moment.locale('fr');
      const day = days_config[moment(date_value).isoWeekday() - 1];
      let availability = [];
      if (state.space.type === 'a_calm_coworking_space') {
        const schedule = state.space.schedule[day] || {};
        const hours_range = numeral(safeNumeral(schedule.to)).subtract(safeNumeral(schedule.from)).value();
        availability.length = hours_range;
        availability = Array.from(availability).map(function (nothing, i) {
          const start_hour = numeral(safeNumeral(schedule.from)).add(i).format('0');
          const infos = {
            start: start_hour + 'h',
            end: numeral(start_hour).add(1).format('0') + 'h'
          };
          const booking_infos = response.booking.find(booking => booking.hour === start_hour);
          infos.remaining_seats = numeral(seats).subtract(safeNumeral(booking_infos?.people_count)).format('0');
          if (infos.remaining_seats <= 0) {
            infos.remaining_seats = '0';
          }
          infos.too_little_seats = infos.remaining_seats < people_count;
          if (infos.too_little_seats) {
            infos.available = false;
          }
          return infos;
        }).filter(infos => infos.available !== false);
        component.setState({
          availability: availability
        });
      } else {
        const bookings = response.booking || [];
        availability = b_seminar_ranges.filter(opt => opt.value !== 'day').map(function (config, i) {
          const infos = {
            start: config.value
          };
          const [is__open, is__custom] = getOpenInfos({
            schedule: state.space.schedule,
            availability: state.space.availabilities,
            type: state.space.type,
            date: date_value,
            period: config.value
          });
          infos.available = is__open;
          if (state.space?.type === 'c_open_coworking_space') {
            infos.remaining_seats = numeral(safeNumeral(seats));
            let morning = 0,
              afternoon = 0;
            bookings.filter(booking => booking.type !== 'day').forEach(function (booking) {
              if (booking.type === 'morning') {
                morning += num(booking.people_count);
              } else {
                afternoon += num(booking.people_count);
              }
            });
            if (morning > afternoon) {
              infos.remaining_seats.subtract(safeNumeral(morning));
            } else {
              infos.remaining_seats.subtract(safeNumeral(afternoon));
            }
            infos.remaining_seats = infos.remaining_seats.format('0');
            if (infos.remaining_seats > 0 === false) {
              infos.remaining_seats = '0';
            }
            infos.too_little_seats = infos.remaining_seats < people_count;
            if (infos.too_little_seats) {
              infos.available = false;
            }
          } else if (bookings?.[0]?.type === 'day')
            // seminar
            {
              infos.available = false;
            } else
            // seminar
            {
              if (is__custom && !is__open) {
                infos.available_type = 'close';
              }
              if (is__open) {
                const booking = bookings.find(booking => booking.type === config.value);
                infos.available = !booking;
              }
            }
          return infos;
        }).filter(infos => infos.available !== false);
        component.setState({
          availability: availability
        });
      }
      if (availability?.length === 0) {
        return component.setState({
          availability_error: true
        });
      }
      component.setState({
        closed: false,
        loading: false,
        availability_error: false
      });
    }).catch(function (error, xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      delete component.requests['fetchAvailability'];
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleStepChange = index => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      step: index
    });
  };
  fetchSpace = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const space_id = window.localStorage.getItem('booking-space-id');
    if (!space_id) {
      return component.setState({
        error: 'Veuillez sélectionner un espace ' + 'avant de procéder à une nouvelle réservation.'
      });
    }
    component.setState({
      loading: true
    });
    qwest.post(action('getAllFrontSpaces'), {
      id: space_id,
      striptags: false
    }).then(function (xhr, response) {
      const space = response.data?.[0];
      if (!space || !space._etablishment) {
        return component.setState({
          error: 'Espace introuvable.'
        });
      }
      const etablishment = space._etablishment;
      if (component.fetched === true) return;
      component.need_availability = true;
      component.fetched = true;
      component.setState({
        space: space,
        meta_title: 'Réservation ' + space.name + ' - ' + etablishment.name
      });
      app.emit({
        event: 'TCPageView',
        source: 'FrontBookingPage',
        data: {
          page: 'reservation',
          type_reservation: space.type === 'coworking' ? 'coworking' : 'seminaire',
          ville_reservation: etablishment.address?.city,
          date_reservation: state.date,
          etablissement: etablishment.name || 'Etablissement',
          nom_espace: space.name,
          creneau_reservation: state.start && state.end ? state.start + 'h-' + state.end + 'h' : state.start === 'afternoon' ? 'Demi-journée - Après midi' : state.start === 'morning' ? 'Demi-journée - Matin' : state.start === 'day' ? 'Journée' : '',
          quantite_siege: state.people,
          unitprice_tf: numeral(safeNumeral(window.localStorage.getItem('amount'))).divide(1.2).format('0.00'),
          unitprice_ati: formatNum(window.localStorage.getItem('amount'), '0.00')
        }
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePaymentSuccess = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      paid: true
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const show_booking_component = state.offline_booking ? !!state.booking_id : state.availability?.length > 0;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      "header-bemit": ['inline'],
      "hide-login": true
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, show_booking_component ? /*#__PURE__*/React.createElement(BookingComponent, {
      space: state.space,
      date: state.date,
      people: state.people,
      start: state.start,
      end: state.end,
      stepChange: component.handleStepChange,
      amount: state.amount,
      disposition: state.disposition,
      onPaymentSuccess: component.handlePaymentSuccess,
      "third-party-auth": true,
      source: "FrontBookingPage",
      offline: state.offline_booking === true,
      paid: state.paid === true
    }) : state.availability_error ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'orange'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Cet espace n'est plus disponible \xE0 ce cr\xE9neau et pour ce nombre de personnes.")), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      href: "/",
      component: Link,
      className: bemit('c-arrow-btn', ['primary']) + ' booking-go-back'
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retour \xE0 l'accueil"))) : undefined, getFormStatus(state, ['v2']))));
    return output;
  }
}
